import { Link } from 'react-router-dom';
import { Card } from '@thegpvc/ui';
import { text, bg, border, cx } from '../../styles/theme';
import { installCommand } from '../../utils/installCommand';

/**
 * Shown on Home when the authenticated user has never uploaded a session
 * (GetConnectionStatus hasAnyUpload === false). Replaces the zeroed hero/volume layout —
 * which reads as "broken or still loading" — with an explicit call to connect
 * the local daemon: what it does, a link to the setup wizard, and the install
 * command as a copy-paste fallback. See the dashboard-empty-and-fallback-states
 * convention (a never-connected account is the canonical no-history case).
 */
export function ConnectDixiePanel() {
  return (
    <Card>
      <Card.Body>
        <div className="mx-auto max-w-xl py-8 text-center">
          <h2 className={cx('text-lg font-semibold', text.primary)}>Connect Dixie to get started</h2>
          <p className={cx('mt-2 text-sm', text.secondary)}>
            Dixie hasn't seen any sessions yet. A small local daemon watches your
            Claude Code logs and uploads them here — install it and this dashboard
            fills in automatically.
          </p>
          <div className="mt-6">
            <Link
              to="/setup"
              className="inline-block rounded-lg bg-orange-500 px-4 py-2 text-sm font-medium text-white hover:bg-orange-600"
            >
              Set up Dixie
            </Link>
          </div>
          <p className={cx('mt-6 text-xs', text.muted)}>Or install it from your terminal:</p>
          <pre
            className={cx(
              'mt-2 overflow-x-auto rounded-lg border p-4 text-left text-sm font-mono',
              bg.surface,
              border.default,
              text.primary,
            )}
          >
            {installCommand()}
          </pre>
        </div>
      </Card.Body>
    </Card>
  );
}
